<template>
  <div v-show="isCardActiveLocal">
    <div class="clickpagequizviewer">
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2 disable-select">
          <h3>{{ question ? question.title : "" }}</h3>
        </div>
      </div>
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2">
          <div v-html="question.questionText"></div>
        </div>
      </div>

      <div v-if="question.imageUrl" class="quizimage">
        <img :src="question.imageUrl" class="clickimageactive" style="width: 100% !important; height: 100%; border-radius:15px;">
      </div>
    </div>
    

    <div class="vx-row mb-5" v-if="question">
      <div class="vx-col w-full mb-6">
        <quill-editor class="" v-model="question.inputAnswer" :options="editorOption" />
      </div>
    </div>
  </div>
</template>

<script>

  
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';

  export default {
    components:{
      quillEditor
    },
    data(){
      return{
        editorOption: {
          modules: {
            toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
          },
        },
      }
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      isStudent: {
        type: Boolean,
        required: false
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          this.$emit("initValues");
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("initValues");
          }
        }
      },
    }
  };
</script>

<style lang="scss">
  #answerTextArea {
    height: 200px;
  }
  .vs-textarea{
    background: white !important;
    color: black !important;
  }
  #answerTextArea {
    .vs-component.vs-con-textarea.vs-textarea-primary{
    border-color: rgb(48, 48, 48) !important;
    }
    
  }

  .textcenter{
    text-align: center !important;
  }

  .quizimage{
    width: 40%;
    max-height: 60%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    padding: 20px 0px;
  }

  @media screen and (max-width: 500px) {
    .quizimage{
      width: 80%;
      max-height: 90%;
    }
  }
</style>
